import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { ProjectsPage } from "./pages/ProjectsPage";
import { VueEnergyPage } from "./pages/VueEnergyPage";
import { ScrollToHash } from "./components/ScrollToHash";
import { Analytics } from "@vercel/analytics/react"
import "./index.css";

export function App() {
  return (
    <BrowserRouter>
      <ScrollToHash />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/vue-smart-home" element={<VueEnergyPage />} />
      </Routes>
      <Analytics />
    </BrowserRouter>
  );
}

export default App;
